<template>
<div class="success" name="success">
  <topNav :title="title"></topNav>
  <div class="payContent">
      <div class="add_info">
        <div class="carInfo">
          <div class="carnum">
            <p class="icon"><img src="../../../static/images/icon_license_plate.png" alt=""></p>
            <p class="input es"><input required type="text" placeholder="请输入车牌号码"></p>
          </div>
          <div class="banknum">
            <p class="icon"><img src="../../../static/images/icon_bank_card.png" alt=""></p>
            <p class="input"><input type="text" placeholder="请输入银行卡号"></p>
          </div>
      </div>
       <div class="phoneIfo">
          <div class="phonenum">
            <p class="icon"><img src="../../../static/images/icon_phone.png" alt=""></p>
            <p class="input es"><input type="text" placeholder="请输入预留手机号"></p>
          </div>
          <div class="codenum">
            <p class="icon"><img src="../../../static/images/icon_verification_code.png" alt=""></p>
            <p class="input"><input type="text" placeholder="手机验证码"></p>
            <p class="codebtn">获取验证码</p>
          </div>
      </div>
      </div>
     <div class="pay_btn" @click="bind_card()">确认绑定</div>
  </div>
</div>

</template>
<script>
import topNav from "../topnav/topnav"
export default {
  name: 'paydetail',
  components:{
     topNav,
  },
  methods:{
   bind_card:function(){
     this.$router.push('/nofeel');

    },
  },
  data() {
    return {
      title: "车牌号码绑定银行卡",
      carnum:"",
      banknum:"",
      phonenum:""
    }
  }
}
</script>
<style>
.pay_btn {
    width: 92%;
    text-align: center;
    height: 2.7rem;
    line-height: 2.7rem;
    background-color: rgb(70,135,248);
    color: white;
    margin: 1.5rem auto;
    border-radius: 5px;
    font-size: 1.1rem;
    -webkit-box-shadow: 0.1rem 0.1rem 0.7rem #A3A3A3;
    box-shadow: 0rem 0.2em 0.8rem #5b82c18a;
    margin-top: 11%;
}
.add_info img{
  width: 100%;
}
.add_info input{
  /* vertical-align: 5px; */
  margin-left: 8px;
  height: 100%;
  width: 100%;
  font-size: 14px;
}
.carInfo{
  background: white;
}
.carInfo>div,.phoneIfo>div{
  text-align: left;
  padding: 17px 0 0 5%;
  display: flex;
}
.phoneIfo{
  background: white;
  margin-top: 5px;
}
.icon{
  width: 6%;
}
.input{
  width: 100%;
  padding-bottom: 17px;
}
.es{
 border-bottom: 1Px solid rgb(245, 244, 244);
}
 input::-webkit-input-placeholder {
 /* placeholder颜色  */
 color: rgb(153,153,153)
}
.codebtn{
  position: absolute;
  right: 15px;
  color: rgb(70,135,248);
  top: 13px;
  font-size: 14px;
}
.codenum{
  position: relative;
}
.phonenum img,.codenum img{
  width: 16px;
}
</style>




// WEBPACK FOOTER //
// src/components/nofeel/bindcard.vue